'use client'
import { ColorButton, SmartLink, Pagination, Table, TableRow, TableHeader, TableCell, MoreButton } from "@/components/ui";
import { Log, Pen, Trash } from "@/assets/icons";
import { UserSearchParams, UserTypeFilterParams, UsersResponse } from "@/types";
import React, { useEffect, useState } from "react";
import { listUsers } from "@/app/api";

export function ManageUsers() {
    const [showObservation, setShowObservation] = useState<Record<string, boolean>>({})
    const [usersData, setUsersData] = useState<UsersResponse>()
    const [filters, setFilters] = useState<UserSearchParams>({
        page: 1,
        perPage: 10,
        order: "desc",
        orderBy: "createdAt",
        userType: "admin",
    });

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const data = await listUsers(filters)
                setUsersData(data)
            } catch (err) {
                console.log("Erro ao carregar usuários: ", err);
            }
        }

        fetchUsers()
    }, [filters]);


    const handleTypeChange = (userType: UserTypeFilterParams) => {
        setFilters({ ...filters, userType, page: 1 })
    };

    const handlePageChange = (page: number) => {
        setFilters({ ...filters, page });
    };

    const toggleExpand = (userId: string, e: React.MouseEvent) => {
        e.stopPropagation();
        setShowObservation(prev => ({
            ...prev,
            [userId]: !prev[userId]
        }))
    };

    const users = usersData?.data || []

    return (
        <div className="pt-8">
            <div className="flex flex-wrap gap-4 md:justify-between justify-center">
                <div className="flex flex-wrap gap-4 justify-center items-center">

                    <ColorButton disabled={filters.userType === 'admin'}
                        onClick={() => { handleTypeChange('admin') }}>
                        Administradores
                    </ColorButton>
                    <ColorButton disabled={filters.userType === 'client'}
                        onClick={() => { handleTypeChange('client') }}>
                        Clientes
                    </ColorButton>
                    <ColorButton disabled={filters.userType === 'seller'}
                        onClick={() => { handleTypeChange('seller') }}>
                        Vendedores
                    </ColorButton>
                    <ColorButton disabled={filters.userType === 'accountant'}
                        onClick={() => { handleTypeChange('accountant') }}>
                        Contadores
                    </ColorButton>
                    <ColorButton disabled={filters.userType === 'inactive'}
                        onClick={() => { handleTypeChange('inactive') }}>
                        Inativos
                    </ColorButton>
                    <ColorButton disabled={filters.userType === 'canceled'}
                        onClick={() => { handleTypeChange('canceled') }}>
                        Cancelados
                    </ColorButton>

                </div>
                <SmartLink type={"internal"} route={"adminUsersNew"}>
                    <ColorButton>Cadastro</ColorButton>
                </SmartLink>
            </div>
            <div className="p-8">
                <div className="hidden md:flex">
                    <Table>
                        <thead>
                            <TableRow>
                                <TableHeader>Código</TableHeader>
                                <TableHeader>Empresa</TableHeader>
                                <TableHeader>Nome</TableHeader>
                                <TableHeader>Email</TableHeader>
                                <TableHeader>Acessos</TableHeader>
                                <TableHeader colSpan={2}>Data do cadastro</TableHeader>
                            </TableRow>
                        </thead>
                        <tbody>
                            {users.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={6} className="text-center">
                                        Não existem usuários dessa categoria.
                                    </TableCell>
                                </TableRow>
                            ) : (users.map((user) => (
                                <React.Fragment key={user.id}>
                                    <TableRow>
                                        <TableCell>{user.code}</TableCell>
                                        <TableCell>{user.userName}</TableCell>
                                        <TableCell>{user.name}</TableCell>
                                        <TableCell>{user.email}</TableCell>
                                        <TableCell>{user.hits}</TableCell>
                                        <TableCell>{new Date(user.createdAt).toLocaleDateString()}</TableCell>
                                        <TableCell>
                                            <MoreButton onClick={(e) => toggleExpand(user.id, e)} />
                                        </TableCell>
                                    </TableRow>
                                    {showObservation[user.id] && (
                                        <TableRow>
                                            <TableHeader colSpan={2}>Observação</TableHeader>
                                            <TableCell colSpan={4}>{user.observation}</TableCell>
                                            <TableCell className="flex flex-col gap-3">
                                                <SmartLink type={"internal"} route={"adminUsersIdUpdate"}
                                                    params={[`${user.id}`]}>
                                                    <Pen />
                                                </SmartLink>
                                                <SmartLink type={"internal"} route={"adminUsersIdLogs"}
                                                    params={[`${user.id}`]}>
                                                    <Log />
                                                </SmartLink>
                                                <SmartLink type={"internal"} route={"adminUsersIdDelete"}
                                                    params={[`${user.id}`]}>
                                                    <Trash />
                                                </SmartLink>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </React.Fragment>
                            ))
                            )
                            }
                        </tbody>

                    </Table>
                </div>

                <div className="flex md:hidden">
                    <Table>
                        <tbody>
                            {users.length === 0 ? (
                                <TableRow>
                                    <TableCell className="text-center">
                                        Não existem usuários dessa categoria.
                                    </TableCell>
                                </TableRow>
                            ) : (users.map((user) => (
                                <TableRow key={user.id}>
                                    <TableHeader>Código</TableHeader>
                                    <TableCell>{user.code}</TableCell>
                                    <TableHeader>Empresa</TableHeader>
                                    <TableCell>{user.userName}</TableCell>
                                    <TableHeader>Nome</TableHeader>
                                    <TableCell>{user.name}</TableCell>
                                    <TableHeader>Email</TableHeader>
                                    <TableCell>{user.email}</TableCell>
                                    <TableHeader>Acessos</TableHeader>
                                    <TableCell>{user.hits}</TableCell>
                                    <TableHeader>Data do cadastro</TableHeader>
                                    <TableCell>{new Date(user.createdAt).toLocaleDateString()}</TableCell>
                                    <TableHeader>Observação</TableHeader>
                                    <TableCell>{user.observation}</TableCell>
                                    <TableCell className="flex gap-10">
                                        <SmartLink type={"internal"} route={"adminUsersIdUpdate"}
                                            params={[`${user.id}`]}>
                                            <Pen />
                                        </SmartLink>
                                        <SmartLink type={"internal"} route={"adminUsersIdLogs"}
                                            params={[`${user.id}`]}>
                                            <Log />
                                        </SmartLink>
                                        <SmartLink type={"internal"} route={"adminUsersIdDelete"}
                                            params={[`${user.id}`]}>
                                            <Trash />
                                        </SmartLink>
                                    </TableCell>
                                    <TableCell className="border-t-2 min-w-40 border-ochre_accent" />
                                </TableRow>
                            ))
                            )
                            }
                        </tbody>
                    </Table>
                </div>
            </div>

            <div>
                {usersData?.pagination &&
                    <Pagination
                        currentPage={usersData.pagination.page}
                        totalPages={Math.ceil(usersData.pagination.total / usersData.pagination.perPage)}
                        onPageChange={handlePageChange}
                    />
                }
            </div>
        </div>
    )
}